import React from "react";
import "./FaqPage.scss";

function FaqPage() {
  return <h1>Faq You</h1>;
}

export default FaqPage;
